import { removeAuthTokens } from './authToken'
export default removeAuthTokens
